import React from "react";

import styles from "./GameItemList.module.scss";
import { GameItemSm } from "../GameItemSm/GameItemSm";
import cx from "classnames";

export const GameItemList = ({ games: gamesArr, customLayout }) => {
  const games = gamesArr.sort((a, b) => new Date(a.date) - new Date(b.date));
  const isOdd = games.length % 2;

  let _games;
  let _lastItem;

  if (!!isOdd) {
    _games = [...games];
    _lastItem = _games.shift();
  } else {
    _games = [...games];
  }
  const middleIndex = Math.ceil(_games.length / 2);
  let leftCol = _games.splice(0, middleIndex);
  if (!!isOdd) leftCol.unshift(_lastItem);
  const rightCol = _games.splice(-middleIndex);
  return (
    <div
      className={cx(
        styles.games,
        customLayout === "isUpcoming" ? styles.is_upcoming : "",
        customLayout === "isCalendar" ? styles.is_calendar : ""
      )}
    >
      {games?.length > 0 ? (
        <>
          <div className={styles.left}>
            {leftCol?.map((game) => (
              <div className={styles.game} key={game._id}>
                <GameItemSm game={game} />
              </div>
            ))}
          </div>
          <div className={styles.right}>
            {rightCol?.map((game) => (
              <div className={styles.game} key={game._id}>
                <GameItemSm game={game} />
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <h2>No games match the criteria</h2>
        </>
      )}
    </div>
  );
};
